import React from 'react'
import { Link, Stack } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'

import { handleLightspeedLinkClick } from '../../../utils/externalLinks'
import type { AgingBucket } from './types'

export const AGING_LABELS: Record<AgingBucket, string> = {
  '0-3m': '0–3 months',
  '3-6m': '3–6 months',
  '6-12m': '6–12 months',
  '12-24m': '12–24 months',
  over_24m: '> 24 months',
  never: 'Never sold',
}

export const renderProductNameLink = (
  name: string,
  sku: string | null,
  link?: string,
): React.ReactNode => {
  if (!link) return name
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Link
        href={link}
        onClick={(e) => handleLightspeedLinkClick(e, link, `Product ${sku || name}`)}
        sx={{
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
          fontWeight: 500,
        }}
      >
        {name}
      </Link>
      <LaunchIcon fontSize="small" sx={{ color: 'text.secondary', fontSize: 14 }} />
    </Stack>
  )
}
